/**
 * Keputusan titik masuk untuk halaman publik. Diimpor main.tsx, jadi berkas ini tidak boleh mengimpor apa pun.
 *
 * - /terms dan /privacy selalu situs ringan.
 * - / untuk tamu adalah halaman depan, untuk member adalah Beranda back office. Situs ringan menunggu /config sebelum
 *   menggambar apa pun, jadi member tidak pernah melihat halaman depan. Petunjuk 'member' di localStorage hanya jalan
 *   pintas supaya member langsung memuat aplikasi penuh tanpa menunggu /config.
 */

export type SitePage = 'landing' | 'terms' | 'privacy';

export type VisitorHint = 'member' | 'guest' | null;

const LEGAL_PAGES: Record<string, SitePage> = { '/terms': 'terms', '/privacy': 'privacy' };

const HINT_KEY = 'kobe.visitor';

/** Halaman situs publik untuk path ini, atau null kalau path milik aplikasi. Garis miring di akhir diabaikan. */
export function sitePageFor(pathname: string): SitePage | null {
  const path = pathname.replace(/\/+$/, '') || '/';
  if (path === '/') return 'landing';
  return LEGAL_PAGES[path] ?? null;
}

/** Situs ringan atau aplikasi penuh. APK Kobe Outlet selalu ke aplikasi penuh, karena / di APK berarti /outlet. */
export function entryFor(pathname: string, { hint, native }: { hint: VisitorHint; native: boolean }): 'site' | 'app' {
  const page = sitePageFor(pathname);
  if (!page) return 'app';
  if (page !== 'landing') return 'site';
  if (native) return 'app';
  return hint === 'member' ? 'app' : 'site';
}

/**
 * Hasil pemeriksaan /config di situs ringan: aplikasi penuh hanya kalau server yakin ada sesi. Server tidak terjangkau
 * atau lambat berarti halaman depan tetap tampil, karena halaman pemasaran tidak boleh bergantung pada API.
 */
export function landingDecision(check: { authenticated: boolean } | 'error' | 'timeout'): 'app' | 'landing' {
  return typeof check === 'object' && check.authenticated ? 'app' : 'landing';
}

/** Back office menerima tamu di /: halaman depan di /, ke login untuk halaman lain. */
export function guestScreen(pathname: string): 'landing' | 'login' {
  return sitePageFor(pathname) === 'landing' ? 'landing' : 'login';
}

function storage(): Storage | null {
  try {
    return globalThis.localStorage ?? null;
  } catch {
    return null;
  }
}

export function readVisitorHint(store: Storage | null = storage()): VisitorHint {
  try {
    const value = store?.getItem(HINT_KEY);
    return value === 'member' || value === 'guest' ? value : null;
  } catch {
    return null;
  }
}

export function rememberVisitor(kind: 'member' | 'guest', store: Storage | null = storage()): void {
  try {
    if (store?.getItem(HINT_KEY) !== kind) store?.setItem(HINT_KEY, kind);
  } catch {
    /* penyimpanan bisa diblokir; keputusan tetap benar, hanya tanpa jalan pintas */
  }
}

export function isNativeShell(): boolean {
  return Boolean((globalThis as { Capacitor?: { isNativePlatform?: () => boolean } }).Capacitor?.isNativePlatform?.());
}
